let utils = require('../../../actions/utils');
let page = require('../../../actions/page');
let footer = require('../../../actions/layout/footer');
let order = require('../../../actions/order');
let analytics = require('../../../actions/analytics');
let payment = require('../../../actions/payment');
let seo = require('../../../actions/seo');

module.exports = [
    payment.fixOrderId,
    analytics.parseUtmFromQuery,
    utils.set('layout', 'payment'),
    utils.set('page.ui.atCenter', true),
    page.setCurrentPage,
    footer.setCopyrightYear,
    order.setOrderLocationToState(['payment', 'redirectLink']),
    utils.setFromArgsToState('redirectType', 'payment.alertType'),
    [
        payment.ifPaymentSuccessful,
        {
            yes: [
                seo.setDashboardMeta('Успешная оплата', 'Оплата успешно завершена'),
                analytics.argsValueEvent({ category: 'post_successful_payment', action: 'see' })
            ],
            no: [ seo.setDashboardMeta('Оплата не прошла', 'Не удалось завершить оплату') ]
        }
    ],
    analytics.pageview
];



// WEBPACK FOOTER //
// ./signals/pages/payment/index.js